import arrayParser from "./arrayParser"

const itemTextTweaker=(element, item, itemText)=>
//handles minor changes to individual items of structured data in the forms to suit text i.e not needing dedicated module to process the form return. More extensive changes are handled by modules in folder "non standard element processors"

//some code written to determine item from itemText - item now sent to this function so this code could be improved to use item instead- future work
{
if (itemText === " smear" || itemText === " trace")
    {
    itemText =`a ${itemText} of`
    }

if ((Object.keys(element).includes("Size_(cm)") || Object.keys(element).includes("Size (cm)"
)) && !isNaN(itemText) && itemText !=="  ")
    {
    itemText = ` a ${itemText}cm`
    }

if (Object.keys(element).includes("Max_Size_(cm)") 
 && !isNaN(itemText) && itemText !== "  ")
    {
    itemText = ` up to ${itemText}cm diameter` 
    }

if (element["symptom"] ==="Unexplained fever" && !isNaN(itemText))
    {
    itemText = ` with a temperature up to ${itemText} degrees celcius`
    }

if (itemText === "single")
    {
    itemText = "a single"
    }

if (item === "Present_for_several:" || item === "Duration:")
    if (element["symptom"]==="Weight Loss")

        {
        itemText+= ` over several ${itemText.toLowerCase()}`   
        } 
    else
        {
        itemText = ` for several ${itemText.toLowerCase()}`  
        } 

if  (element["symptom"] === "Unexplained bleeding (poss haematological)")
        {
        if (item === "symptom")
            {
             if (element["Type_of_blood:"] !== " ")
                {
                let bloodType = element["Type_of_blood:"].replaceAll("blood", "")
                bloodType = bloodType.toLowerCase()
                itemText = ` unexplained ${bloodType} bleeding`
                }
            else
                {
                itemText = " unexplained bleeding"
                }
            }
            if (item === "Type_of_blood:")
                {
                itemText = ""
                }

        else if (item === "Site(s)_of_bleeding")
            {
            itemText = ` from their ${itemText}`
            }
        }


else if (itemText === " other abdominal mass")
    {
    itemText = " abdominal mass"
    }

else if (element["symptom"] ==="Haematemesis" && (itemText.includes("blood") || itemText.includes("coffee")))
    {
    itemText = ` containing ${itemText}`  
    }

else if (element["symptom"] === "Rectal Bleeding" && (itemText.includes("blood")))
    {
    itemText = ` with ${itemText}`  
    }

else if  (itemText ===" rectal or anal mass / ulcer") 
    {itemText=""
    itemText += (element["Involving"] === "" ? " rectal or anal" : "")

    itemText += (element["Type_of_lesion"] ==="" ? " mass or ulcer" : "")
    }

else if (itemText === " hist of recurrent / frequent utis")
{
itemText = " recurrent UTIs" 
}

else if (itemText === " urinary frequency / urgency")
    {
    itemText = " urinary"
    if (element["Problem:"] === "")
        {
        itemText += " frequency & urgency"
        } 
    }

else if (itemText === " urinary hesitancy / retention / nocturia")
    {
    itemText = " urinary"
    if (element["Problem:"] === " ")
        {
        itemText += " hesitancy, retention & nocturia"
        } 
    }

else if (itemText.includes(" blood clots"))
    {
    itemText = ` with ${itemText}`
    }

else if (element["symptom"] === "Erectile dysfunction")
    {
     if (element["Occurance:"] !== "")
        {
        if (itemText === " always") 
            {
            itemText = " persistent"
            }
        else if (itemText === " intermittently")
            {
            itemText = " intemittent"
            }
        }

    if (element["Nocturnal_erections:"] !== "")
        {
        if (itemText === " yes") 
            {
            itemText =  " with nocturnal erections"
            }
        else if (itemText === " no")
            {
            itemText = " with no nocturnal erections"
            }
        }
    }

else if (element["symptom"] === "Other unexplained or persistent testicular symptoms")
    {
    if (itemText === " other unexplained or persistent testicular symptoms")
        {
        itemText = " testicular symptoms"
        }

    else if (itemText.length > 9)
        {
        itemText = ` described as "${itemText}"`
        }
    } 

else if (itemText === " untreated sti")
    {
    if(element["Infective_agent"] === "")
        {
        itemText= " an untreated STI"
        }
    else
        {
        itemText= " untreated"
        }
    }

else if (element["symptom"] === "Penile mass / ulcer")
    {
    if (element["Area_involved"] !== "")
        {
        if (["base", "shaft", "glans", "foreskin"].some((item)=>{return itemText.includes(item)}))
            {
            itemText = ` involving the ${itemText}`
            }
        }
    if (itemText === " penile mass / ulcer")
        {
        itemText = " penile"
        if (element["Mass_or_Ulcer"] === "")
            {
            itemText += " mass or ulcer"
            } 
                 
        }
    }

else if (element["symptom"] === "Unexplained or persistent foreskin / glans symptoms")
    {
    if (itemText === " unexplained or persistent foreskin / glans symptoms")
        {
        if (element["Involving:"]=== "")
            {
            itemText =  "foreskin / glans symptoms"
            }
        else
            {
            itemText = " symptoms"
            } 
        if (element["Description"] !== "")
            {
            itemText += " described as"
            }  
        }
    }

else if (element["symptom"] === "Unexplained Vaginal Discharge")
    {
    if (itemText === " unexplained vaginal discharge")
        {
        itemText = " vaginal discharge"
        }
    if (itemText === " yes")
        {
        itemText = " with blood staining"
        }
    else if (itemText === " no")
        {
        itemText = " with no blood staining"
        }   
    } 

else if (element["symptom"] === "Post menopausal bleeding"  && itemText.includes(" blood"))
    {
    itemText = ` with ${itemText}`
    }

else if (itemText === " cervix exam consistent with cancer")
    {
    itemText = " findings on cervical examination consisent with cancer"
    if (element["description"] !== "")
        {
        itemText += " described as"
        }
    }

    
else if (element["symptom"] === "Vulval lump, ulceration or bleeding")
{ 
    if (element["Area_involved"] !== "")
    {
    if (["perineum", "labia majora", "labia minora", "vaginal introitus", "vagina "].some((item)=>{return itemText.includes(item)}))
        {
        itemText = ` involving the ${itemText}`
        }
    }
    if (itemText === " vulval lump, ulceration or bleeding")
        {
        itemText = " vulval"
        if (element["Problem"] === "")
            {
            itemText += " lump, ulcer or bleeding"
            }      
        } 
    }

else if (element["symptom"] === "Vaginal Mass")
    {
    if (element["Area_involved"] !== "")
    {
    if (["perineum", "labia majora", "labia minora", "vaginal introitus", "vagina "].some((item)=>{return itemText.includes(item)}))
        {
        itemText = ` involving the ${itemText}`
        }
    }
    if (itemText === " vaginal mass")
    {
        itemText = " vaginal"
        if (element["Problem"] === "")
            {
            itemText += " mass"
            }     
    }
}
else if (element["symptom"] === "Haemoptysis")
    {
    if (["mixed with sputum ", "frank blood"].some((item)=>{return itemText.includes(item)}))
        {
        itemText = ` (${itemText})`
        }

    else if (itemText.includes("blood"))
        {
        itemText = ` with  ${itemText}`
        }

    else if (["yes", "no"].some((item)=>{return itemText.includes(item)}))
        {
        itemText = ` ${(element["Character:"] === "" ? "" : " and")
        } ${(itemText === "yes" ? " with" : "without")} blood clots`
        }
    }

    else if (element["symptom"] ===  "Cough")
    // puts an "a" in the sentence
    {
    if (element["Type_of_cough"] === "" && itemText.includes("cough"))
        {
        itemText = ` a cough`
        }
    else if (["dry", "productive"].some((item)=>{return itemText.includes(item)}))
        { 
        itemText = ` a ${itemText}`
        }
    }

else if (element["symptom"] ===  "Persistent/ recurrent chest infection")
    // puts an "a" in the sentence
    {
    if (itemText === " persistent/ recurrent chest infection")
        {
        if (element["Frequency"] === "" && element["Present_for_several:"] === "")
            {
            itemText = " a persistent or recurrent chest infection"
            }
        else  
            { 
            itemText = ` had a chest infection`
            }
        }
    }

else if (itemText ===   " supraclavicular / cervical lymphadenopathy")
    {
    if (element["Site(s)"] === " ")
        {
        itemText = "supraclavicular or cervical lymphadenopthy"
        }
    else 
        {
        itemText = " cervical lymphadenopthy"   
        }
    }

else if (element["symptom"] === "Chest signs suggesting pleural disease")
    if (itemText === " right" || itemText === " left")
        {
        itemText = `${itemText} sided`
        }
    if (element["Findings"] !== " ")
        if (["poor expansion", "dullness to percussion", "decreased breath sounds", "pleural rub"].some((item)=>{return itemText.includes(item)}))
         {
        itemText = ` including ${itemText}`
         }

 else if (element["symptom"] === "Unexplained breast lump")
    {
    if ([" upper outer", " upper inner", " lower outer", " lower inner"].some((item)=>{return itemText.includes(item)}))
        {
        itemText = ` ${itemText} quadrant`
        }
    if (itemText === " unexplained breast lump")
        {
        itemText = " breast lump"
        }
    }

else if (itemText ===  " unilateral nipple discharge")
    {
    itemText = " nipple discharge"
    }

else if (element["symptom"] ===  
"Other concerning breast changes")
    { 
    if (element["Description"] !== "")
    {
    if (![" left", " right", " bilateral", " concerning breast changes", " days", " weeks"," months"," years"].some((item)=>{return itemText.includes(item)}))
        {   
        itemText = ` described as ${element["Description"]}`
        }
    }

    if ([" left", " right", " bilateral"].includes(itemText))
        {
        itemText=""
        }

    if (itemText ===" other concerning breast changes")
       {
        if (element["Side"] ==="")
        {
        itemText = " concerning breast changes"
        }
        else
        {
        itemText =` concerning ${element["Side"].toLowerCase()} breast changes`
        }
       }
    }

    else if (element["symptom"]=== "Unexplained lump in axilla" )
        {
        if ([" left", " right", " bilateral"].some((item)=>{return itemText.includes(item)}))
            {   
            itemText = ""
            }
            
        if (itemText === " unexplained lump in axilla")
            {
            itemText = ` ${(element["Side"] === "Bilateral" ? "bilateral" : "")} ${((element["Number:"] === "Multiple" ||  element["Side"] === "Bilateral") ? " lumps" : " lump")} in the ${(element["Side"] !== "Bilateral" ? element["Side"].toLowerCase() : "")} ${(element["side"] === "Bilateral" ? " axillae": " axilla")}`
            }
        }

   else if (itemText === " unexplained neck lump" )
    {
    itemText =` neck ${(element["Side"] === "Bilateral" ? "lumps" : "lump")}`
    }

    else if (itemText === " oral ulcer for >3 weeks")
        {
        itemText = ` ${(element["Site"] ===  
        " " ? "oral " : "")} ${(element["Mass_or_Ulcer"] === "" ? "ulcer" : "")}`
        }
    else if (itemText === " lip or oral lump")
    {
    itemText = ` ${(element["Site"] ===  
    " " ? "lip or oral " : "")} ${(element["Mass_or_Ulcer"] === "" ? "lump" : "")}`
    }

else if (element["symptom"] ===  
"Red or red/white oral patch (poss erythroleukoplakia)")
    {
    if (item === "Side_of_mouth")
        {
        itemText = ""
        }

    if (item === "Area_involved" && element["Area_involved"] !== " ")
        {
        itemText = ` involving their ${(element["Side_of mouth"] !== "" ? (element["Side_of_mouth"].toLowerCase()) : "")}
            ${itemText}`
        }
    else if (item === "Area_involved" && element["Side_of_mouth"] !== " ")
        {
        itemText = ` involving the ${(element["Side_of_mouth"] === "Central" ? "centre of the mouth" : `the ${element["Side_of_mouth"].toLowerCase()} side of their mouth`)}`
        }

    if (item === "Features" && element["Features"] !==" ")
        {
        itemText = ` with ${itemText}`
        }

    if (item ===  "Features_suggesting" && element["Features_suggesting"] !== " ")
        {
        itemText = ` suggestive of  ${itemText}`
        }

    if (item === "symptom")
        {
        itemText = ` oral patch ${element["Features_suggesting"] ===" " ? " suggestive of leukoplakia" : ""}`
        }
    }


if (element["symptom"] === "thyroid")
    {
    
    if (item === "Thyroid_Auscultation:" && element["Thyroid_Auscultation:"] !== "")
        {
        itemText = `${(element["Thyroid_Auscultation:"]  === "Bruit" ? " with an" : " with no")} audible bruit on auscultation`
        }
    
    if (item === "symptom")
        {
        if (element["Nodularity"] !== "Diffusely enlarged")
            {
            itemText = " thyroid lump"
            }
        }   
    }

if (element["symptom"] === "Squint (children)")
    {
    if (item === "symptom")
       {
        itemText = " squint"
       }
    else if (item === "Description"  && element["Description"] !== "") 
        {
        itemText = ` described as ${element["Description"]}`
        }    
    }

if (element["symptom"] === "Headache")
    {
    if (item === "Side(s)")
        {
        itemText = itemText.replace("right", "right sided")
        itemText = itemText.replace("left", "left sided")
        }

    if (item === "Headache_features" && (element["Headache_features"].length > 0 || element["Other_features"] !== ""))
        { 
        let featureList = []  
        featureList.push(...element["Headache_features"])
        if (element["Other_features"] !== "")
            {
            featureList.push(element["Other_features"])
            }
        itemText = arrayParser(featureList)
        itemText= ` with ${itemText}`
        }
    if (item === "Other_features")
        {
        itemText = ""
        }
    }

    if (element["symptomGroup"] === "childConcern")
        {
        if (item === "symptom")
            itemText = "cause for persistent concern (child under 15)"

        else if (item === "Nature_of_concern:" && element["Nature_of_concern:"] !== "")
            {
            itemText = ` regarding ${element["Nature_of_concern:"]}`
            }
        }
    
    
return itemText
}

export default itemTextTweaker